import router from './router'
import { useAppStoreWithOut } from '@/store/modules/app'
import { useCache } from '@/hooks/web/useCache'
import { RouteRecordRaw } from 'vue-router'
import { useTitle } from '@/hooks/web/useTitle'
import { useNProgress } from '@/hooks/web/useNProgress'
import { usePermissionStoreWithOut } from '@/store/modules/permission'
import { useDictStoreWithOut } from '@/store/modules/dict'
import { usePageLoading } from '@/hooks/web/usePageLoading'
import { ElMessage } from 'element-plus';
import utils from '@/utils/cookie'
import { GetTenantInfo, GetUserInfo } from './utils/auth'
// import { GetSysServices } from '@/api/system_setting'
import { useCommonStoreWithOut } from '@/store/modules/common'
import { useI18n } from '@/hooks/web/useI18n'
import { joinPaths } from './utils'

const permissionStore = usePermissionStoreWithOut()

const appStore = useAppStoreWithOut()
const commonStore = useCommonStoreWithOut()

const dictStore = useDictStoreWithOut()

const { wsCache } = useCache()

const { start, done } = useNProgress()

const { loadStart, loadDone } = usePageLoading()

const whiteList = ['/login'] // 不重定向白名单

router.beforeEach(async (to, from, next) => {
  // start()
  // loadStart()
  console.log("to:", to)
  console.log("from:", from)
  //wsCache.get(appStore.getUserInfo)
  if (utils.getCookie('EIName')) {
  // if (true || utils.getCookie('EIName')) {
    if (to.path === '/login') {
      // next({ path: '/' })
      next()
    } else if (['Forbidden','NoFind'].includes(to.name as any)) {
      next()
    } else {
      if (permissionStore.getIsAddRouters) {
        // 由于存在权限过滤，所以当path=/的时候需要在有权限的route里找到第一个进行redirect
        let targetRoute:any = null
        if (to.path === '/') {
          targetRoute = findFirstAuthRoute()
        }
        if (targetRoute) {
          const nextData:any = {name: targetRoute.name, query: {}}
          if (to.query.hideMenu) nextData.query.hideMenu = to.query.hideMenu
          if (to.query.hideHeader) nextData.query.hideHeader = to.query.hideHeader
          next(nextData)
          console.log("After add router redirect route:", targetRoute)
        } else {
          console.log("After add router to route:", to.path)
          next()
        }
        return
      }

      const { t } = useI18n()
      let err:any = await GetTenantInfo()
      if (err) {
        ElMessage.error(t('auth.error.getUserOrgInfoFail'))
        next({name:'Forbidden'})
        return
      }
      err = await GetUserInfo()
      // myself获取无权限或报错时，清除cookie跳转登录页面
      if (err) {
        ElMessage.error(t('auth.error.userHasNoPermissions'))
        next({name:'Forbidden'})
        return
      }

      // 开发者可根据实际情况进行修改
      // const roleRouters = wsCache.get('roleRouters') || []
      // const userInfo = wsCache.get(appStore.getUserInfo)

      // 是否使用动态路由
      // if (appStore.getDynamicRouter) {
      //   userInfo.role === 'admin'
      //     ? await permissionStore.generateRoutes('admin', roleRouters as AppCustomRouteRecordRaw[])
      //     : await permissionStore.generateRoutes('test', roleRouters as string[])
      // } else {
        await permissionStore.generateRoutes('none')
      // }

      permissionStore.getAddRouters.forEach((route) => {
        router.addRoute(route as unknown as RouteRecordRaw) // 动态添加可访问路由表
      })
      const redirectPath = from.query.redirect || to.path
      const redirect = decodeURIComponent(redirectPath as string)
      let nextData = to.path === redirect ? { ...to, replace: true } : { path: redirect }
      // 当nextData未找到时，也要进行一次redirect
      if (nextData.path !== '/' && !permissionStore.getAuthRouters.find(parent => {
        if (nextData.path===parent.path) return true
        return parent.children?.find(child => nextData.path===joinPaths(parent.path,child.path))
      })) {
        console.log('adding router path not found:', nextData.path)
        nextData = { path: '/',  }
      }
      permissionStore.setIsAddRouters(true)
      next(nextData)
    }
  } else {
    console.log("whiteList:", whiteList)
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      // 没有EIName 全部重定向到登录页
      // 并且需要把hideMenu和hideHeader带上
      const nextData:any = {path: '/login', query: {}}
      if (to.query.hideMenu) nextData.query.hideMenu = to.query.hideMenu
      if (to.query.hideHeader) nextData.query.hideHeader = to.query.hideHeader
      next(nextData)
    }
  }
})

function findFirstAuthRoute() {
  for (const parent of permissionStore.getAuthRouters as any) {
    if (parent.children) {
      for (const child of parent.children) {
        return child
      }
    }
  }
  return null
}

router.afterEach((to) => {
  useTitle(to?.meta?.title as string)
  done() // 结束Progress
  loadDone()
})
